
export default {
  props: {
    name: {type: String, required: true},
    logo: {type: String, default: undefined},
    size: {type: String, default: '1.6rem'},
    icon: {type: String, default: undefined},
    stroke: {type: String, default: '#414651'},
    strokeWidth: {type: String, default: '1'}
  }
}
